import React, { FC } from 'react';

export const NotFound: FC = () => (
	<div>
		<h2>404 Not Found</h2>
		<div>Page not found.</div>
	</div>
);
